import { Entity } from "../model";
import { loadingAction } from "../reducer/loading";
import { store } from "../store";
import { ConditionsOptions, FindManyOptions, GetOptions, PaginationOptions, PaginationResult, ServiceApi } from "./ServiceApi";

class ServiceApiWithLoading<T extends Entity> extends ServiceApi<T> {

    private loading: boolean;

    constructor(entity: string, loading = true) {
        super(entity);
        this.getList = this.getList.bind(this);
        this.getById = this.getById.bind(this);
        this.insert = this.insert.bind(this);
        this.update = this.update.bind(this);
        this.delete = this.delete.bind(this);
        this.count = this.count.bind(this);
        this.promiseWithLoading = this.promiseWithLoading.bind(this);
        this.loading = loading;
    }

    async promiseWithLoading<P>(promise: Promise<P>): Promise<P> {
        var result = null;
        try {
            this.loading && store.dispatch(loadingAction(true));
            result = await promise;
        } finally {
            this.loading && store.dispatch(loadingAction(false));
        }
        return result;
    }

    getList(options: FindManyOptions<T>): Promise<T[]>;
    getList(): Promise<T[]>;
    getList(options: FindManyOptions<T> = {}): Promise<T[]> {
        return this.promiseWithLoading(super.getList(options));
    }

    getById(id: number | string, options: GetOptions<T> = {}): Promise<T> {
        return this.promiseWithLoading(super.getById(id, options));
    }

    insert(item: Partial<T>): Promise<T> {
        return this.promiseWithLoading(super.insert(item));
    }

    // insertWithId(item: Partial<T>): Promise<T> {
    //     return this.promiseWithLoading(super.insertWithId(item));
    // }

    update(id: number | string, item: Partial<T>, throwError: boolean = true) {
        return this.promiseWithLoading(super.update(id, item, throwError));
    }

    count(options: ConditionsOptions<T>): Promise<number> {
        return this.promiseWithLoading(super.count(options));
    }

    delete(id: number | string) {
        return this.promiseWithLoading(super.delete(id));
    }

    getPagination(options: PaginationOptions<T>): Promise<PaginationResult<T>>;
    getPagination(): Promise<PaginationResult<T>>;

    getPagination(options: PaginationOptions<T> = {}): Promise<PaginationResult<T>> {
        return this.promiseWithLoading(super.getPagination(options));
    }

    promiseGetBlob(url: string, useAuthentication: boolean = true) {
        return this.promiseWithLoading(super.promiseGetBlob(url, useAuthentication));
    }

}

export {
    ServiceApiWithLoading as ServiceApi
};
